import { render, staticRenderFns } from "./CreateOrUpdateMessageType.vue?vue&type=template&id=e130b0e6&scoped=true&"
import script from "./CreateOrUpdateMessageType.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateMessageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e130b0e6",
  null
  
)

export default component.exports